import { geoMercator, geoPath } from 'd3-geo';
import { polygonArea } from 'd3-polygon';
import { sum } from 'd3-array';
import bC from '@turf/boolean-clockwise';
import proj4 from 'proj4';
const AC_M2 = 4046.86

const getTM = ([longitude, latitude]) => `+proj=tmerc +lat_0=${latitude} +lon_0=${longitude} +units=m +no_defs`;

const getRingArea = coords => {
  const TM = getTM(coords[0]);
  const projected = coords.map(p => proj4('EPSG:4326', TM, p));
  return Math.abs(polygonArea(projected)) / AC_M2;
}

const getPolyArea = rings => {
  return getRingArea(rings[0]) - sum(rings.slice(1), getRingArea);
}

export const getArea = geometry => {
  // if (!geometry.type === 'Polygon') 
  if (geometry.type === 'MultiPolygon') {
    return sum(geometry.coordinates, c => getPolyArea(c))
  } else if (geometry.type === 'Polygon') {
    return getPolyArea(geometry.coordinates);
  } else {
    throw new Error('needs to be a Polygon');
  }
}

export const getTotalAcres = boundary => sum(boundary.features, f => getArea(f.geometry));

const fixClock = g => {
  if (g.type === 'Polygon') {
    if (!bC(g.coordinates[0])) {
      g.coordinates[0].reverse();
    }
  }
  return g;
}

export const GeoSVG = ({geometry}) => {
   	// const g = rewind(geometry);
    const g = fixClock(geometry);

   	const proj = geoMercator().fitExtent([[5, 5], [95, 95]],  g);
   	const d = geoPath(proj)(g);
   	return <svg width={100} height={100}>
   		<g>
   			<path d={d} style={{fill: 'none', stroke: 'black'}} />
   		</g>
   	</svg>;
}
